<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p
        class="display-2 text-center font-weight-bold indigo--text"
      >The troubling journey of a name in the U.S.</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" align="center">
        <v-container style="width:680px">
          <p class="text-sm-left font-weight-bold">The troubling journey of a name in the U.S.</p>
          <p class="text-sm-right">
            <i>For NSZ.</i>
          </p>
          <p class="text-sm-right">
            <i>Thanks for helping me find myself.</i>
          </p>

          <p class="text-sm-left">I.</p>
          <p class="text-sm-left">August 18, 2016.</p>
          <p class="text-sm-left">
            <i>First Name?</i>
          </p>
          <p class="text-sm-left">-Doménica.</p>
          <p class="text-sm-left">
            <i>How do you spell it?</i>
          </p>
          <p class="text-sm-left">-D. O. M. E. N. I. C. A.</p>
          <p class="text-sm-left">
            <i>Middle Initial?</i>
          </p>
          <p class="text-sm-left">-M.</p>
          <p class="text-sm-left">
            <i>Last Name?</i>
          </p>
          <p class="text-sm-left">-Montaño Moncayo</p>
          <p class="text-sm-left">
            <i>How do you spell that?</i>
          </p>
          <p class="text-sm-left" style="text-decoration: line-through;">-M. O. N. T. A. Ñ. O</p>
          <p class="text-sm-left">-M. O. N. T. A. N. O</p>
          <p class="text-sm-left">
            <i>As in Montana the State with an O in the end instead?</i>
          </p>
          <p class="text-sm-left">-Yes??</p>
          <p class="text-sm-left">
            <i>Sweet!</i>
          </p>
          <p class="text-sm-left">-and the rest is M. O. N. C. A. Y. O.</p>
          <p class="text-sm-left">
            <i>Okay. What’s your full middle name young lady?</i>
          </p>
          <p class="text-sm-left">-Michelle.</p>
          <p class="text-sm-left">
            <i>Welcome to the United States of America, you are now Michelle Montano.</i>
          </p>
          <p class="indent text-sm-left">1.</p>
          <br />
          <p class="text-sm-left">I had just arrived,</p>
          <p class="text-sm-left">when they</p>
          <p class="text-sm-left">translated me</p>
          <p class="text-sm-left">into English.</p>
          <p class="text-sm-left">Michelle,</p>
          <p class="text-sm-left">they translated,</p>
          <p class="text-sm-left">and I,</p>
          <p class="text-sm-left">didn’t understand.</p>
          <p class="text-sm-left">Montano,</p>
          <p class="text-sm-left">they translated</p>
          <p class="text-sm-left">And weirdly,</p>
          <p class="text-sm-left">it felt safe.</p>
          <p class="text-sm-left" style="text-decoration: line-through;">Doménica</p>
          <p class="text-sm-left">was too hard,</p>
          <p class="text-sm-left">the “ñ”</p>
          <p class="text-sm-left">too foreign,</p>
          <p class="text-sm-left">and Moncayo,</p>
          <p class="text-sm-left">my mother’s</p>
          <p class="text-sm-left">last name,</p>
          <p class="text-sm-left">too long.</p>
          <p class="text-sm-left">Michelle</p>
          <p class="text-sm-left">Montano</p>
          <p class="text-sm-left">they translated,</p>
          <p class="text-sm-left">and it</p>
          <p class="text-sm-left">didn’t sound</p>
          <p class="text-sm-left">so bad,</p>
          <p class="text-sm-left">in their</p>
          <p class="text-sm-left">mouths.</p>
          <p class="text-sm-left">Michelle</p>
          <p class="text-sm-left">Montano</p>
          <p class="text-sm-left">they translated,</p>
          <p class="text-sm-left">And I</p>
          <p class="text-sm-left">became that,</p>
          <p class="text-sm-left">that I hated my mom</p>
          <p class="text-sm-left">to call me,</p>
          <p class="text-sm-left">when she was mad.</p>
          <p class="text-sm-left">It</p>
          <p class="text-sm-left">hurt</p>
          <p class="text-sm-left">me.</p>
          <p class="text-sm-left">But,</p>
          <p class="text-sm-left">I let them</p>
          <p class="text-sm-left">translate me</p>
          <p class="text-sm-left">because</p>
          <p class="text-sm-left">in this country</p>
          <p class="text-sm-left">Michelle</p>
          <p class="text-sm-left">Montano</p>
          <p class="text-sm-left">was safer</p>
          <p class="text-sm-left">than</p>
          <p class="text-sm-left">Doménica</p>
          <p class="text-sm-left">Michelle</p>
          <p class="text-sm-left">Montaño</p>
          <p class="text-sm-left">Moncayo.</p>
          <p class="text-sm-left">III.</p>
          <p class="text-sm-left">Michelle, never spelled</p>
          <p class="text-sm-left">her name for others,</p>
          <p class="text-sm-left">only for</p>
          <p class="text-sm-left">herself.</p>
          <p class="text-sm-left">What’s your name?</p>
          <p class="text-sm-left">People asked her,</p>
          <p class="text-sm-left" style="text-decoration: line-through;">Doménica</p>
          <p class="text-sm-left">Michelle.</p>
          <p class="text-sm-left">Oh nice! they said</p>
          <p class="text-sm-left">How exciting are</p>
          <p class="text-sm-left">familiar</p>
          <p class="text-sm-left">names.</p>
          <p class="text-sm-left">Of course! everything</p>
          <p class="text-sm-left">is nice when you don’t</p>
          <p class="text-sm-left">have to make any</p>
          <p class="text-sm-left">sacrifice.</p>
          <p class="text-sm-left">Michelle, yes!</p>
          <p class="text-sm-left">what a wonderful name!</p>
          <p class="text-sm-left">It only hurts</p>
          <p class="text-sm-left">her.</p>
          <p class="text-sm-left">In public or with friends,</p>
          <p class="text-sm-left">Michelle only</p>
          <p class="text-sm-left">spoke</p>
          <p class="text-sm-left">English.</p>
          <p class="text-sm-left">Spanish, used to</p>
          <p class="text-sm-left">hide in her mind</p>
          <p class="text-sm-left">like a dark</p>
          <p class="text-sm-left">secret.</p>
          <p class="text-sm-left">Abandoned, desolate</p>
          <p class="text-sm-left">she left her soul.</p>
          <p class="text-sm-left">Her heart, her</p>
          <p class="text-sm-left">self.</p>
          <p class="text-sm-left">Michelle, flowed like water</p>
          <p class="text-sm-left">in their tongues.</p>
          <p class="text-sm-left">And burned like acid in</p>
          <p class="text-sm-left">hers.</p>
          <p class="text-sm-left">Michelle was a liar,</p>
          <p class="text-sm-left">who told lies.</p>
          <p class="text-sm-left">Michelle, was a</p>
          <p class="text-sm-left">lie.</p>
          <p class="text-sm-left">But lies sometimes are better</p>
          <p class="text-sm-left">than truths. They are easier to say,</p>
          <p class="text-sm-left">and they keep us</p>
          <p class="text-sm-left">safe.</p>
          <p class="text-sm-left">IV.</p>
          <p
            class="text-sm-left"
          >Doménica Michelle Montaño Moncayo was born on June 1st, 1997 in that place, where the Earth divides in halves, and yet doesn’t collapse. It was a Sunday. Doménica means Sunday. Her mom says it was a Friday. She was never good at math.</p>
          <p
            class="text-sm-left"
          >Her mom named her Doménica because sonaba bonito. What a great reason! And because there was this Ecuadorian journalist whose name was Doménica and everyone loved. Doménica also wants to be a journalist.</p>
          <p
            class="text-sm-left"
          >Doménica loves her name. Unless her mother screams it from downstairs because she is running late. Doménica is original. It feels special. Unique. Yet, weirdly enough nobody really calls her Doménica. Almost never.</p>
          <p
            class="text-sm-left"
          >In Ecuador everyone has a nickname. Doménica never calls any of her friends by their actual names. They are Vane, Yadi, Emi, Chiqui, Coso, Zambra, Mabe, and so on. Nicknames are a sign of love. And so, she has a nickname too: Dome.</p>
          <p
            class="text-sm-left"
          >That is /d̪oˈme/. Not /dōm/ like dome. And it’s spelled Dome. Not Domé, like most people do in the U.S.. Domé, in Spanish is the past perfect simple of “domar” which literally means “to tame.” So when people say domé, they are literally saying that they tamed something or someone. That’s quite an unusual way of calling someone. Dome with no accents is fine.</p>
          <p
            class="text-sm-left"
          >And she likes it because it reminds her of her patria—of that little country in the middle of the globe that she calls home. And she mostly likes it because Dome is herself, and she is untranslatable and does not need an English version.</p>
          <p class="text-sm-left">By Doménica Montaño</p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>

<style scoped>
.indent {
  text-indent: 1.9em;
}
</style>